import e from "react";
import { ChevronUp as l, ChevronDown as s } from "@olxbr/ds-icons";
import { sendClickEvent as m } from "../../utils/sendClickEvent.js";
import { Button as c } from "../../../Button/Button.js";
import { cls as i } from "../../../../helpers/cls.js";
const f = _ref => {
  let {
    children: o,
    isVisible: n
  } = _ref;
  const [t, r] = e.useState(!1);
  return e.createElement("section", {
    className: "olx-seo-footer__tab-content-wrapper"
  }, e.createElement("div", {
    className: i("olx-seo-footer__tab-content", t && "olx-seo-footer__tab-content--expanded")
  }, o), e.createElement(c, {
    tabIndex: n ? 0 : -1,
    className: "olx-seo-footer__more-button",
    variant: "link-button",
    size: "small",
    icon: t ? e.createElement(l, null) : e.createElement(s, null),
    "data-ds-component": "DS-TabPanel-Button",
    onClick: () => {
      r(a => !a), m("more_links", "footer");
    }
  }, t ? "Mostrar menos" : "Mostrar mais"));
};
export { f as TabContent };